import React from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { User, Bell, Lock, CreditCard, Globe, HelpCircle, ChevronRight } from 'lucide-react';
interface SettingRow {
  label: string;
  value?: string;
}
interface SettingSection {
  icon: React.ReactNode;
  title: string;
  rows: SettingRow[];
}
export function ImpostazioniPage() {
  const sections: SettingSection[] = [{
    icon: <User size={18} data-id="element-3155" />,
    title: 'Account',
    rows: [{
      label: 'Profilo'
    }, {
      label: 'Email e Password'
    }]
  }, {
    icon: <Bell size={18} data-id="element-3156" />,
    title: 'Notifiche',
    rows: [{
      label: 'Preferenze Notifiche'
    }]
  }, {
    icon: <Lock size={18} data-id="element-3157" />,
    title: 'Sicurezza',
    rows: [{
      label: 'Autenticazione a due fattori'
    }]
  }, {
    icon: <CreditCard size={18} data-id="element-3158" />,
    title: 'Fatturazione',
    rows: [{
      label: 'Metodi di Pagamento'
    }, {
      label: 'Storico Fatture'
    }]
  }, {
    icon: <Globe size={18} data-id="element-3159" />,
    title: 'Lingua e Regione',
    rows: [{
      label: 'Lingua',
      value: 'Italiano'
    }]
  }, {
    icon: <HelpCircle size={18} data-id="element-3160" />,
    title: 'Supporto',
    rows: [{
      label: 'Centro Assistenza'
    }, {
      label: 'Contattaci'
    }]
  }];
  return <MobileLayout data-id="element-3161">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-3162">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-3163">
          Impostazioni
        </h1>
      </div>

      {/* Settings Sections */}
      <div className="space-y-4" data-id="element-3164">
        {sections.map(section => <div key={section.title} className="bg-white rounded-xl border border-gray-200 p-4 lg:p-6" data-id="element-3165">
            <h2 className="text-sm font-semibold text-navy mb-2 flex items-center gap-2" data-id="element-3166">
              {section.icon}
              {section.title}
            </h2>
            {/* Rows: full-width, separated by dividers */}
            <div className="-mx-4 lg:-mx-6 divide-y divide-gray-100 border-t border-gray-100" data-id="element-3167">
              {section.rows.map(row => <button key={row.label} className="w-full flex items-center justify-between px-4 lg:px-6 py-3.5 hover:bg-gray-50 transition-colors text-left min-h-[44px]" data-id="element-3168">
                  <span className="text-sm text-navy" data-id="element-3169">{row.label}</span>
                  {row.value ? <span className="text-xs text-gray-500" data-id="element-3170">{row.value}</span> : <ChevronRight size={16} className="text-gray-400" data-id="element-3171" />}
                </button>)}
            </div>
          </div>)}

        {/* Logout Button */}
        <button className="w-full px-4 py-3 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-3172">
          Esci dall'Account
        </button>
      </div>
    </MobileLayout>;
}